// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"604":"21a1f7de","905":"4b5b930c"}[chunkId] + ".css";
};